/**
 * URM 运营中心
 */
import { md5, QueryString } from "@src/common/dependencies";

class URM {
  channel_id = "e1ea2623d9c9d63f";
  token = "7F091FC1-0092-A647-4DEB-4423CD64A5D2";
  url = "/apiu/feedback";

  /**
   * 公共参数
   */
  baseParams = {};

  constructor () {
    window._urm = this;

    this.init();
  }

  // 更新公参
  updateBaseParams (params) {
    this.baseParams = {
      ...this.baseParams,
      ...params,
    }
  }

  // 拼接参数
  getReportParams (params) {
    params.unix_time = Math.floor(+new Date() / 1000);
    params.sign = md5(`${this.channel_id}${this.token}${params.unix_time}`);

    return {
      ...this.baseParams,
      ...params,
    }
  }

  /**
   * 上报
   * @param {Object} params 
   * @example
   *  // 综合反馈
   *  report({
   *    tag : "feedback",       // feedback 综合反馈  single 单条反馈
   *    content : "123", // 用户反馈内容
   *  });
   * 
   *  // 单条消息
   *  report({
   *    tag : "single",         // feedback 综合反馈  single 单条反馈
   *    message_id : "",        // 消息 ID
   *    content : "",           // 内容
   *    like_type : "",         // 点赞 1 点踩 2
   *  });
   */
  report (params) {
    return fetch(this.url, {
      headers: {
        "content-type" : "application/x-www-form-urlencoded;charset=UTF-8",
      },
      body: QueryString.stringify(this.getReportParams(params)),
      method: "POST",
    })
    .then(res => res.json());
  }

  init () {
    this.updateBaseParams({
      channel_id : this.channel_id,
      source : "web",
    });
  }
}

const urm = new URM();

// debug
window._urm = urm;

export default urm;